<template>
  <div
    class="tw-flex tw-flex-col tw-gap-[30px] md:tw-gap-[28px] tw-text-[var(--my-black)] tw-text-[16px] md:tw-text-[18px]"
  >
    <div class="text-block">
      <p>{{ $t("donor_dashboard.my_contacts_label_last_name", "Last Name") }}</p>
      <p class="tw-text-right rtl:tw-text-left tw-text-[var(--my-primary)]">
        {{ contact.last_name }}
      </p>
    </div>
    <div class="text-block">
      <p>{{ $t("donor_dashboard.my_contacts_label_phone_number", "Phone Number") }}</p>
      <p class="tw-text-right rtl:tw-text-left tw-text-[var(--my-primary)]">
        {{ contact.phone ? contact.phone : $t("donor_dashboard.my_contacts_label_na", "N/A") }}
      </p>
    </div>
    <div class="text-block">
      <p>{{ $t("donor_dashboard.my_contacts_label_email", "Email") }}</p>
      <p class="tw-text-right rtl:tw-text-left tw-text-[var(--my-primary)]">
        {{ contact.email ? contact.email : $t("donor_dashboard.my_contacts_label_na", "N/A") }}
      </p>
    </div>
    <div class="text-block">
      <p>{{ $t("donor_dashboard.my_contacts_label_address", "Address") }}</p>
      <p class="tw-text-right rtl:tw-text-left tw-text-[var(--my-primary)]">
        {{
          contact.address1 ? contact.address1 : $t("donor_dashboard.my_contacts_label_na", "N/A")
        }}
      </p>
    </div>
    <div class="text-block">
      <p>{{ $t("donor_dashboard.my_contacts_label_expected_donation", "Expected Donation") }}</p>
      <p class="tw-text-right rtl:tw-text-left tw-text-[var(--my-primary)]">
        {{
          contact.expected_donation_currency
            ? new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: contact.expected_donation_currency,
              }).format(contact.expected_donation_amount)
            : contact.expected_donation_amount
        }}
      </p>
    </div>
    <div class="text-block">
      <p>{{ $t("donor_dashboard.my_contacts_label_relationship", "Relationship") }}</p>
      <p class="tw-text-right rtl:tw-text-left tw-text-[var(--my-primary)]">
        {{
          contact.relationship && relationships[contact.relationship]
            ? $t(
                relationships[contact.relationship].nameKey,
                relationships[contact.relationship].nameDefault
              )
            : $t("donor_dashboard.my_contacts_label_na", "N/A")
        }}
      </p>
    </div>
    <div class="text-block">
      <p>{{ $t("donor_dashboard.my_contacts_label_status", "Status") }}</p>
      <p class="tw-text-right rtl:tw-text-left tw-text-[var(--my-primary)]">
        {{
          contact.status && statuses[contact.status]
            ? $t(statuses[contact.status].nameKey, statuses[contact.status].nameDefault)
            : $t("donor_dashboard.my_contacts_label_na", "N/A")
        }}
      </p>
    </div>
  </div>
</template>

<script>
import { statuses, relationships } from "@/views/my-contacts/constants";

export default {
  name: "my-contact-data",

  data() {
    return {
      statuses,
      relationships,
    };
  },

  props: {
    contact: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-block {
  @apply tw-flex tw-justify-between tw-gap-[16px];

  p {
    @apply tw-mb-0;
  }
}
</style>
